module.exports = __webpack_public_path__ + "static/img/07.361b624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/07.png
// module id = MMeO
// module chunks = 1